import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef, useState } from "react";
import BuyReportFormConfig from "./form";
import { BuyReportFormDataType } from "@/formTypes/BuyReportFormDataType";
import { Button, Col, Row } from "reactstrap";
import { getMonthBoundaries } from "@utils/Utils";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type BuyReportFormProps = {
}

const BuyReportForm = forwardRef<DynamicFormRef, BuyReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      formRef.current?.resetFormValue({
        month,
        year
      })
    }, [])

    const getFormConfig = () => {
      return BuyReportFormConfig;
    }

    const generateForm = (formData: BuyReportFormDataType) => {
      const { startDate, endDate } = getMonthBoundaries(`${formData.year}`, `${formData.month}`, false)
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/buyByMonth/${formData.providerId}/${startDate}/${endDate}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        window.open(`/user/reports/excel/buyByMonth/${formData.providerId}/${startDate}/${endDate}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<BuyReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default BuyReportForm;